import { getLicenseKeyDashboard } from '@/api/license-list/getLicenseKeyDashboard';
import { GetLicenseKeyDashboardResponse } from '@/api/type/types';
import { fonts } from '@/theme/fonts';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const LicenseDashboard = () => {
  const [dashboard, setDashboard] =
    useState<GetLicenseKeyDashboardResponse | null>(null);
  const { t } = useTranslation();

  const fetchLicenseDashboard = useCallback(async () => {
    const res = await getLicenseKeyDashboard();
    if (res.isSuccess) {
      setDashboard(res.data);
    }
  }, []);

  useEffect(() => {
    fetchLicenseDashboard();
  }, [fetchLicenseDashboard]);

  const summaryList = [
    {
      title: t('licenseManagement.issueAll'),
      count: dashboard?.allCount ?? 0,
      desc: t('licenseManagement.totalIssuedLicenseKeys'),
    },
    {
      title: t('licenseManagement.status.unregistered'),
      count: dashboard?.createdCount ?? 0,
      desc: t('licenseManagement.status.pending'),
    },
    {
      title: t('licenseManagement.status.registered'),
      count: dashboard?.registeredCount ?? 0,
      desc: t('licenseManagement.status.activated'),
    },
    {
      title: t('licenseManagement.status.revoked'),
      count: dashboard?.revokedCount ?? 0,
      desc: t('licenseManagement.status.unavailable'),
    },
  ];

  return (
    <CardWrapper>
      {summaryList.map((item) => (
        <Card key={item.title}>
          <CardTitle>{item.title}</CardTitle>
          <CardCount>{item.count}</CardCount>
          <CardDesc>{item.desc}</CardDesc>
        </Card>
      ))}
    </CardWrapper>
  );
};

export default LicenseDashboard;

const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`;

const Card = styled.div`
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  min-height: 110px;
`;

const CardTitle = styled.div`
  font-size: 14px;
  font-weight: ${fonts.weight.medium};
  color: #6b7280;
`;

const CardCount = styled.div`
  margin: 12px 0 4px;
  font-size: 28px;
  line-height: 1;
  font-weight: ${fonts.weight.bold};
  color: #111827;
`;

const CardDesc = styled.div`
  font-size: 13px;
  color: #9ca3af;
`;
